// Trip IDs are assigned by the report API as parent.subset (for example 41.1).
// Keep unmatched subsets visible rather than guessing a parent from row position.
export function groupTripRows(report) {
  const parents = new Map(report.filter(item => !item.isSubTrip).map(item => [String(item.tripId), []]));
  const unmatched = [];
  report.filter(item => item.isSubTrip).forEach(item => {
    const parentId = String(item.tripId).split(".")[0];
    if (parents.has(parentId)) parents.get(parentId).push(item);
    else unmatched.push({ item, groupClass: "", parentId: null });
  });
  const rows = [];
  report.filter(item => !item.isSubTrip).forEach(item => {
    const children = parents.get(String(item.tripId)).slice().sort((a, b) =>
      String(a.started).localeCompare(String(b.started)) || String(a.tripId).localeCompare(String(b.tripId), undefined, { numeric: true }));
    rows.push({ item, groupClass: children.length ? "report-trip-group report-trip-parent" : "", parentId: null });
    children.forEach((child, index) => rows.push({
      item: child,
      parentId: String(item.tripId),
      groupClass: `report-trip-group report-trip-subset${index === children.length - 1 ? " report-trip-group-end" : ""}`
    }));
  });
  return rows.concat(unmatched);
}
